// const moment = require('moment');
// import { gsap } from "gsap";
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
// gsap.registerPlugin(ScrollTrigger);
import { Navigation, Pagination, Autoplay, EffectFade, Swiper } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export function index() {
  const ceremonyslide = new Swiper(".toppage__project__ceremonyslide", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 5000,
    },
  });
  const active = new Swiper(".toppage__project__active", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 5000,
    },
  });
  const bookslide = new Swiper(".toppage__project__bookslide", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 2000,
  });
  const bookslide__genki = new Swiper(".toppage__project__bookslide__genki", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 2000,
  });

  const voiceswiper = new Swiper(".toppage__voice__list", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 30,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 5000,
    },
  });
  const messageswiper = new Swiper(".toppage__message__list", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 30,
    loop: true,
    loopFillGroupWithBlank: true,
    freeMode: true,
    speed: 10000,
    autoplay: {
      delay: 1,
    },
  });

  const shuffle = ([...array]) => {
    for (let i = array.length - 1; i >= 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  $(window).on("load", function () {
    $(".toppage__loader__logo").delay(1200).fadeOut("slow");
    $(".toppage__loader")
      .delay(1500)
      .fadeOut("slow", function () {
        $("body").addClass("loader__close");
      });
    $(".toppage__loader__bg").on("animationend", function () {
      const imgarray = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
      ];
      const shufflearray = shuffle(imgarray);

      for (let index = 0; index <= shufflearray.length; index++) {
        $(".toppage__mainimage .photo" + (index + 1)).css({
          background:
            "url(assets/img/foundation/top/mainimage/photo" +
            shufflearray[index] +
            ".jpg)",
        });
        $(".toppage__mainimage .photo" + shufflearray[index])
          .delay(200 * index)
          .fadeIn(1000);

        if (index === shufflearray.length) {
          $(".toppage__mainimage h1")
            .delay(200 * index + 1000)
            .fadeIn(1000);
        }
      }
    });
  });
}
